let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ffZTP")).then(() => parcelRequire('gSGzI'));